module.exports = __webpack_public_path__ + "static/media/fotokapak.cb64616d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fotokapak.png
// module id = 314
// module chunks = 0